import React from 'react';
import Slider from '../../../Slider';
import subfolderSliderStyles from './SubfolderSlider.scss';
export const SubfolderSlider = ({ children, disableArrows })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: subfolderSliderStyles['slider-wrapper']
    }, /*#__PURE__*/ React.createElement(Slider, {
        className: subfolderSliderStyles['slider'],
        disableArrows: disableArrows
    }, children));
};
SubfolderSlider.displayName = 'SubfolderSlider';
export default SubfolderSlider;
